import { render } from "./ClassgroupList.vue?vue&type=template&id=0b65ecef&scoped=true&ts=true"
import script from "./ClassgroupList.vue?vue&type=script&lang=ts"
export * from "./ClassgroupList.vue?vue&type=script&lang=ts"

import "./ClassgroupList.vue?vue&type=style&index=0&id=0b65ecef&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/com.latudio.www.teachers_staging/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b65ecef"]])

export default __exports__